import api from '@/api';
import { API_BASE_URL } from '..';
import {
  BankAccountSettings,
  BankAccountSettingsCreateRequest,
  BankAccountSettingsUpdateRequest,
} from './BankAccountsSettings.types';

const CONTROLLER_URL = `${API_BASE_URL}/bankAccountSettings`;

export async function getBankAccountSettings(bankAccountId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${bankAccountId}`,
    null,
  )) as unknown;

  return result as BankAccountSettings;
}

export async function createBankAccountSettings(
  obj: BankAccountSettingsCreateRequest,
) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}

export async function updateBankAccountSettings(
  obj: BankAccountSettingsUpdateRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.bankAccountId}`,
    obj,
    null,
  )) as unknown;

  return result;
}
